import React, { useCallback, useMemo, useState } from 'react';
import CaDialog from 'src/components/CaDialog';
import EntityInstance from 'src/components/EntityInspector/EntityInspectorDialog/EntityInstance';
import EntityCollection from 'src/components/EntityInspector/EntityInspectorDialog/EntityCollection';
import { isCentral, isCollection, isInstance } from 'src/components/EntityInspector/tools';
import Utils from 'src/utils';
import CheckBox from 'src/components/Inputs/CheckBox';
import { makeStyles } from '@material-ui/core';
import { stopPropagation } from 'src/helpers/FPUtils';
import EntityContext from 'src/components/EntityInspector/context';
const useStyles = makeStyles((theme) => ({
    settings: {
        position: 'sticky',
        top: 0,
        backgroundColor: theme.palette.background.paper,
        paddingBottom: theme.spacing(1),
        display: 'flex',
        gap: theme.spacing(2)
    }
}));
function EntityInspectorDialog({ onClose, entity, endpoint }) {
    const classes = useStyles();
    const [fullWidth, setFullWidth] = useState(false);
    const entryPoint = useMemo(() => {
        const capitalize = Utils.strings.capitalize;
        const endpointPrefix = isCentral(endpoint) ? 'Central ' : '';
        const entryInfo = Object.entries(entity).map(([key, value]) => `${capitalize(key)}: ${value}`).join(' | ');
        return `${endpointPrefix}${entryInfo}`;
    }, [entity, endpoint]);
    const renderContent = useCallback(() => {
        if (isInstance(entity)) {
            return React.createElement(EntityInstance, { entity: entity });
        }
        else if (isCollection(entity)) {
            return React.createElement(EntityCollection, { entity: entity });
        }
        else {
            return React.createElement("div", null, "Unknown entity type");
        }
    }, [entity]);
    const ctxValue = useMemo(() => ({ endpoint }), [endpoint]);
    return (React.createElement(EntityContext.Provider, { value: ctxValue },
        React.createElement(CaDialog, { title: entryPoint, open: true, onClose: onClose, maxWidth: "xl", width: fullWidth ? '100%' : 1000, fullWidth: true, onClick: stopPropagation },
            React.createElement("div", { className: classes.settings },
                React.createElement(CheckBox, { label: "Full width view", onChange: (e) => setFullWidth(e.target.checked), checked: fullWidth })),
            renderContent())));
}
export default EntityInspectorDialog;
